import { render } from "./VtoCirclesContainer.vue?vue&type=template&id=771f57af"
import script from "./VtoCirclesContainer.vue?vue&type=script&lang=js"
export * from "./VtoCirclesContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__